import React, { useEffect, useState } from "react";
import "./styles.scss";

const getFormattedTimerValue = (time) => {
  if (time < 0) {
    return "";
  } else {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
  }
};
let countDownTimer = null;
const Counter = (props) => {
  const { countDownTimeValue, countOver } = props;
  const [state, setState] = useState({
    countDownTimeValue,
  });

  const resetTimer = () => {
    clearInterval(countDownTimer);
    countDownTimer = null;
    countOver(true);
  };

  useEffect(() => {
    countDownTimer = setInterval(() => {
      setState((prev) => {
        return {
          ...prev,
          countDownTimeValue: prev.countDownTimeValue - 1,
        };
      });
    }, 1000);

    return () => {
      resetTimer();
    };
  }, []);

  useEffect(
    () => {
      if (state.countDownTimeValue < 0 && countDownTimer) {
        resetTimer();
      }
    },
    [state.countDownTimeValue, countOver]
  );

  return (
    <span className="timer-resend">
      {getFormattedTimerValue(state.countDownTimeValue)}
    </span>
  );
};

export default Counter;
